import { getTranslation } from './config';

const FILESIZE_DIVIDE_GB = 1024 * 1024 * 1024;
const FILESIZE_DIVIDE_MB = 1024 * 1024;
const FILESIZE_DIVIDE_KB = 1024;

/**
 * Human readable filesizes according to Beckhoff Standard.
 * Examples: 99kB, 0,1 MB, 9,9 MB, 10 MB, 100 MB, 1,1 GB
 * @param filesize
 * @param separator
 * @param translations
 * @returns
 */
export default function humanFile(filesize: number) {
  let readableValue = '';
  const separator = getTranslation('decimal_separator');

  // >= 1 GB
  if (filesize >= 1048471142) {
    const value = (filesize / FILESIZE_DIVIDE_GB).toFixed(1);
    readableValue = `${value.replace('.', separator)} ${getTranslation('gigabyte')}`;
  }
  // >= 10 MB && < 1 GB
  else if (filesize >= 10380902 && filesize < 1048471142) {
    const value = (filesize / FILESIZE_DIVIDE_MB).toFixed(0);
    readableValue = `${value.replace('.', separator)} ${getTranslation('megabyte')}`;
  }
  // >= 100 kb && < 10 MB
  else if (filesize >= 102400 && filesize < 10380902) {
    const value = (filesize / FILESIZE_DIVIDE_MB).toFixed(1);
    readableValue = `${value.replace('.', separator)} ${getTranslation('megabyte')}`;
  }
  // < 100 kb
  else if (filesize < 102400) {
    const value = (filesize / FILESIZE_DIVIDE_KB).toFixed(0);
    readableValue = `${value.replace('.', separator)} ${getTranslation('kilobyte')}`;
  }

  return readableValue;
}
